import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'headerMenus';
export const headerMenusActions = makeActions(MODEL_NAME, 'id', 'cms');

export const getAllHeaderMenus = headerMenusActions.getAll;
export const editHeaderMenus = headerMenusActions.edit;
export const createHeaderMenus = headerMenusActions.create;
export const getByIdHeaderMenus = headerMenusActions.getDataById;
